module.exports = __webpack_public_path__ + "img/encom_official_2.594d8f16.png";